<template>
  <div>
    <page-header title="系统管理" description="管理公开舆情的数据源、平台策略、任务、接口和运行日志"/>
    <el-tabs v-model="tab" v-loading="loading" element-loading-text="正在加载系统配置…" @tab-click="handleTabClick">
      <el-tab-pane label="基础配置" name="basic">
        <el-card><basic-settings :value="basic" :saving="savingBasic" @save="saveBasic"/></el-card>
      </el-tab-pane>
      <el-tab-pane label="数据源" name="source">
        <el-card>
          <data-source-settings
            :value="tikhub"
            :operator-value="tikhubOperator"
            :operator-error="tikhubOperatorError"
            :saving="savingKey"
            :deleting="deletingKey"
            :operator-saving="savingOperatorKey"
            :operator-deleting="deletingOperatorKey"
            @save-key="saveKey"
            @delete-key="deleteKey"
            @save-operator-key="saveOperatorKey"
            @delete-operator-key="deleteOperatorKey"
            @manage-operator="tab = 'operator'"
          />
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="Codex 运营代理" name="operator">
        <el-card><tik-hub-operator-settings v-if="tab === 'operator'"/></el-card>
      </el-tab-pane>
      <el-tab-pane label="作品监测账号" name="creator-account">
        <el-card><creator-account-settings/></el-card>
      </el-tab-pane>
      <el-tab-pane label="公开舆情平台" name="policy">
        <el-card>
          <platform-policy
            :value="policies"
            :readiness="readiness"
            :endpoints="endpoints"
            :verifying="verifyingPlatform"
            :saving="savingPolicy"
            @save="savePolicy"
            @verify="verifyPlatform"
          />
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="接口配置" name="endpoint">
        <el-card><endpoint-manager @changed="refreshEndpoints"/></el-card>
      </el-tab-pane>
      <el-tab-pane label="任务中心" name="task">
        <el-card><task-center v-if="tab === 'task'"/></el-card>
      </el-tab-pane>
      <el-tab-pane label="日志中心" name="log">
        <el-card>
          <el-form inline class="log-filters">
            <el-input v-model.trim="logFilters.runId" placeholder="运行ID" clearable @keyup.enter.native="searchLogs"/>
            <el-select v-model="logFilters.platform" placeholder="全部平台" clearable>
              <el-option label="微博" value="weibo"/>
              <el-option label="抖音" value="douyin"/>
              <el-option label="快手" value="kuaishou"/>
              <el-option label="哔哩哔哩" value="bilibili"/>
              <el-option label="微信公众号" value="wechat_mp"/>
            </el-select>
            <el-select v-model="logFilters.decision" placeholder="全部判断" clearable>
              <el-option label="无风险" value="safe"/>
              <el-option label="低风险" value="low_risk"/>
            </el-select>
            <el-button type="primary" @click="searchLogs">查询</el-button>
            <el-button @click="resetLogs">重置</el-button>
          </el-form>
          <el-table :data="logs" empty-text="暂无操作日志">
            <el-table-column prop="created_at" label="时间"/>
            <el-table-column prop="log_type" label="类型"/>
            <el-table-column label="平台"><template slot-scope="s">{{ platformName(s.row.platform) }}</template></el-table-column>
            <el-table-column label="动作" min-width="150"><template slot-scope="s">{{ actionLabel(s.row.action) }}</template></el-table-column>
            <el-table-column label="状态" width="90"><template slot-scope="s">{{ statusLabel(s.row.status) }}</template></el-table-column>
            <el-table-column prop="summary_text" label="说明" min-width="320" show-overflow-tooltip/>
            <el-table-column label="详情" width="80">
              <template slot-scope="scope">
                <el-button type="text" @click="showLogDetail(scope.row)">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="log-pagination"><el-pagination background layout="total, prev, pager, next, jumper" :current-page="logPage" :page-size="logPageSize" :total="logTotal" @current-change="changeLogPage"/></div>
        </el-card>
      </el-tab-pane>
    </el-tabs>

    <el-dialog title="日志详情" :visible.sync="logDetailVisible" width="760px">
      <pre class="log-detail">{{ prettyLog(selectedLog) }}</pre>
    </el-dialog>

  </div>
</template>

<script>
import { yuqingApi } from '@/api/yuqing'
import PageHeader from '../components/PageHeader.vue'
import BasicSettings from './BasicSettings.vue'
import DataSourceSettings from './DataSourceSettings.vue'
import TikHubOperatorSettings from './TikHubOperatorSettings.vue'
import PlatformPolicy from './PlatformPolicy.vue'
import EndpointManager from './EndpointManager.vue'
import CreatorAccountSettings from './CreatorAccountSettings.vue'
import TaskCenter from './TaskCenter.vue'

export default {
  components: { PageHeader, BasicSettings, DataSourceSettings, TikHubOperatorSettings, PlatformPolicy, EndpointManager, CreatorAccountSettings, TaskCenter },
  data () {
    const requestedTab = this.$route.query.tab
    return {
      tab: ['basic', 'source', 'operator', 'creator-account', 'policy', 'endpoint', 'task', 'log']
        .includes(requestedTab) ? requestedTab : 'basic',
      basic: {},
      tikhub: {},
      tikhubOperator: {},
      tikhubOperatorError: '',
      policies: [],
      readiness: [],
      endpoints: [],
      logs: [],
      logFilters: { runId: '', platform: '', decision: '' },
      logPage: 1,
      logPageSize: 50,
      logTotal: 0,
      selectedLog: null,
      logDetailVisible: false,
      verifyingPlatform: '',
      loading: false,
      savingBasic: false,
      savingPolicy: '',
      savingKey: false,
      deletingKey: false,
      savingOperatorKey: false,
      deletingOperatorKey: false
    }
  },
  mounted () {
    this.load()
  },
  methods: {
    handleTabClick (tab) {
      if (tab && tab.name === 'log') this.refreshLogs()
    },
    showLogDetail (log) {
      this.selectedLog = log
      this.logDetailVisible = true
    },
    platformName (value) { return ({ weibo: '微博', douyin: '抖音', kuaishou: '快手', bilibili: '哔哩哔哩', wechat_mp: '微信公众号' })[value] || value || '-' },
    actionLabel (value) {
      return ({
        candidate_processed: '候选处理留痕',
        screening_decision_recorded: 'AI判断留痕',
        screening_decision_reused: '复用历史判断',
        platform_keyword_completed: '品牌词处理完成',
        platform_completed: '平台采集完成',
        platform_item_failed: '单条内容采集失败'
      })[value] || value || '-'
    },
    statusLabel (value) { return ({ success: '成功', completed: '完成', partial_failed: '部分完成', failed: '失败', running: '进行中' })[value] || value || '-' },
    prettyLog (log) {
      if (!log) return ''
      const value = { ...log }
      for (const field of ['summary', 'error']) {
        if (!value[field]) continue
        try {
          value[field] = JSON.parse(value[field])
        } catch (ignored) {
          // 兼容历史纯文本日志，保留原文展示。
        }
      }
      return JSON.stringify(value, null, 2)
    },
    async load () {
      if (this.loading) return
      this.loading = true
      this.tikhubOperatorError = ''
      try {
        const operatorStatus = yuqingApi.get('settings/tikhub/operator').catch(error => {
          this.tikhubOperatorError = error.message || '运营代理配置状态读取失败'
          return {}
        })
        const [basic, tikhub, tikhubOperator, policies, readiness, endpoints, logs] = await Promise.all([
          yuqingApi.get('system/basic-settings'),
          yuqingApi.get('settings/tikhub'),
          operatorStatus,
          yuqingApi.get('system/platform-policies'),
          yuqingApi.get('platform-readiness'),
          yuqingApi.get('endpoints'),
          yuqingApi.get('system/logs', { currentPage: 1, pageSize: this.logPageSize })
        ])
        this.basic = basic
        this.tikhub = tikhub
        this.tikhubOperator = tikhubOperator
        this.policies = policies.policies || []
        this.readiness = readiness.readiness || []
        this.endpoints = endpoints.endpoints || []
        this.logs = logs.logs || []
        this.logTotal = logs.total || 0
      } catch (error) {
        this.$message.error(error.message)
      } finally {
        this.loading = false
      }
    },
    async refreshReadiness () {
      const result = await yuqingApi.get('platform-readiness')
      this.readiness = result.readiness || []
    },
    async refreshLogs (resetPage) {
      try {
        if (resetPage) this.logPage = 1
        const params = { currentPage: this.logPage, pageSize: this.logPageSize }
        if (this.logFilters.runId) params.runId = this.logFilters.runId
        if (this.logFilters.platform) params.platform = this.logFilters.platform
        if (this.logFilters.decision) params.decision = this.logFilters.decision
        const result = await yuqingApi.get('system/logs', params)
        this.logs = result.logs || []
        this.logTotal = result.total || 0
      } catch (error) {
        this.$message.error(error.message || '操作日志刷新失败')
      }
    },
    searchLogs () { return this.refreshLogs(true) },
    resetLogs () {
      this.logFilters = { runId: '', platform: '', decision: '' }
      return this.refreshLogs(true)
    },
    changeLogPage (page) {
      this.logPage = page
      this.refreshLogs(false)
    },
    async refreshEndpoints () {
      try {
        this.endpoints = (await yuqingApi.get('endpoints')).endpoints || []
        await this.refreshLogs()
      } catch (error) {
        this.$message.error(error.message || '接口状态刷新失败')
      }
    },
    async verifyPlatform (platform) {
      if (this.verifyingPlatform) return
      this.verifyingPlatform = platform.platform
      try {
        await yuqingApi.post(`platforms/${encodeURIComponent(platform.platform)}/smoke`, {})
        await this.refreshReadiness()
        await this.refreshLogs()
        const readiness = this.readiness.find(item => item.platform === platform.platform)
        if (readiness && readiness.search_ready) {
          this.$message.success(`${platform.display_name}验证通过，现在可以开启自动舆情`)
          return
        }
        const errors = ((readiness && readiness.checks) || [])
          .filter(check => !check.passed && check.error_summary)
          .map(check => check.error_summary)
        const detail = Array.from(new Set(errors)).join('；')
        this.$message.error(detail || `${platform.display_name}验证未通过，请检查数据源配置`)
      } catch (error) {
        this.$message.error(error.message)
      } finally {
        this.verifyingPlatform = ''
      }
    },
    async saveBasic (value) {
      if (this.savingBasic) return
      this.savingBasic = true
      try {
        this.basic = await yuqingApi.put('system/basic-settings', value)
        await this.refreshLogs()
        this.$message.success('基础配置已保存')
      } catch (error) {
        this.$message.error(error.message)
      } finally {
        this.savingBasic = false
      }
    },
    async savePolicy (value) {
      if (this.savingPolicy) return
      this.savingPolicy = value.platform
      try {
        await yuqingApi.put('system/platform-policies', value)
        await this.refreshLogs()
        this.$message.success('平台策略已保存')
      } catch (error) {
        this.$message.error(error.message)
      } finally {
        this.savingPolicy = ''
      }
    },
    async saveKey (key) {
      if (this.savingKey || this.deletingKey) return
      if (!key) return this.$message.warning('请输入 TikHub API Key')
      this.savingKey = true
      try {
        await yuqingApi.put('settings/tikhub', { api_key: key })
        this.$message.success('公开数据采集凭证已保存')
        await this.load()
      } catch (error) {
        this.$message.error(error.message)
      } finally {
        this.savingKey = false
      }
    },
    async deleteKey () {
      if (this.savingKey || this.deletingKey) return
      this.deletingKey = true
      try {
        await yuqingApi.delete('settings/tikhub')
        this.$message.success('公开数据采集凭证已删除')
        await this.load()
      } catch (error) {
        this.$message.error(error.message)
      } finally {
        this.deletingKey = false
      }
    },
    async saveOperatorKey (key) {
      if (this.savingOperatorKey || this.deletingOperatorKey) return
      if (!key) return this.$message.warning('请输入运营代理 TikHub API Key')
      this.savingOperatorKey = true
      try {
        this.tikhubOperator = await yuqingApi.put(
          'settings/tikhub/operator',
          { api_key: key }
        )
        this.tikhubOperatorError = ''
        await this.refreshLogs()
        this.$message.success('Codex 运营代理凭证已保存并生效')
      } catch (error) {
        this.$message.error(error.message)
      } finally {
        this.savingOperatorKey = false
      }
    },
    async deleteOperatorKey () {
      if (this.savingOperatorKey || this.deletingOperatorKey) return
      this.deletingOperatorKey = true
      try {
        this.tikhubOperator = await yuqingApi.delete('settings/tikhub/operator')
        this.tikhubOperatorError = ''
        await this.refreshLogs()
        const fallback = this.tikhubOperator.source === 'SERVER_CONFIG'
        this.$message.success(fallback
          ? '页面凭证已删除，当前已回退到服务器配置'
          : 'Codex 运营代理凭证已删除')
      } catch (error) {
        this.$message.error(error.message)
      } finally {
        this.deletingOperatorKey = false
      }
    }
  }
}
</script>

<style scoped>
.log-filters { margin-bottom: 12px; }
.log-filters .el-input { width: 260px; }
.log-filters .el-select { width: 150px; }
.log-pagination { display: flex; justify-content: flex-end; margin-top: 16px; }
.log-detail {
  max-height: 60vh;
  margin: 0;
  padding: 16px;
  overflow: auto;
  color: #303133;
  background: #f5f7fa;
  border-radius: 4px;
  white-space: pre-wrap;
  word-break: break-all;
}
</style>
